import { timelineItemClasses } from '@mui/lab';
import type { SxProps, Theme, TooltipProps } from '@mui/material';

// Common tooltip styling
const tooltipSlotProps: TooltipProps['slotProps'] = {
  tooltip: {
    sx: {
      bgcolor: 'rgba(97, 97, 97, 0.95)',
      borderRadius: '6px',
      fontSize: '0.75rem',
      py: 0.75,
      px: 1.25,
      // Because on mobile it goes up to 24 otherwise
      mt: '14px !important',
    },
  },
  arrow: {
    sx: {
      color: 'rgba(97, 97, 97, 0.95)',
    },
  },
};

// Common tooltip props including touch support
export const tooltipProps: Partial<TooltipProps> = {
  arrow: true,
  enterTouchDelay: 0,
  leaveTouchDelay: 1500,
  slotProps: tooltipSlotProps,
};

export const quickActionButtonSx = {
  flex: 1,
  minWidth: { xs: 0, sm: 'auto' },
  '& .button-label': {
    display: { xs: 'none', sm: 'inline' },
  },
} as const;

export const compactFeedActionButtonSx = {
  minWidth: 'auto',
} as const;

/** Shared sx for the clickable snippet container at the bottom of activity cards */
export const snippetContainerSx: SxProps<Theme> = {
  mt: 1.5,
  mx: -1.5,
  mb: -1.5,
  pt: 0.75,
  pb: 0.75,
  px: 1.5,
  bgcolor: 'grey.50',
  borderTop: '1px dashed',
  borderColor: 'grey.300',
  borderBottomLeftRadius: '10px',
  borderBottomRightRadius: '10px',
  cursor: 'pointer',
  transition: 'all 0.15s ease',
  '&:hover': {
    bgcolor: 'grey.100',
  },
};

/** Shared color for MapPin icons in snippet address rows */
export const snippetIconColor = '#94a3b8';

export const ghostButtonSx: SxProps<Theme> = {
  p: 0,
  minWidth: 0,
  textTransform: 'none',
  color: 'text.secondary',
  '&:hover': {
    bgcolor: 'transparent',
    color: 'text.primary',
  },
  '&:focus': { color: 'text.secondary' },
};

export const timelineStyles: SxProps<Theme> = {
  p: 0,
  m: 0,
  [`& .${timelineItemClasses.root}:before`]: { flex: 0, padding: 0 },
  [`& .${timelineItemClasses.root}`]: { minHeight: 0 },
  '& .MuiTimelineContent-root': { pb: 1, minWidth: 0 },
};
